import React, { useMemo, useEffect } from 'react'
import Header from '../../../components/Header/Header'
import { AppBody, AppContainer, AppBodyBailleur, AppContent } from '../../../styles/App.styled';
import { Navigate, Route, useLocation, Routes, useNavigate } from 'react-router-dom';
import Menu from '../../Menu/Menu'
import HomeIcon from '@mui/icons-material/Home';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import BadgeIcon from '@mui/icons-material/Badge';
import ArticleIcon from '@mui/icons-material/Article';
import SaveIcon from '@mui/icons-material/Save';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useTranslation } from 'react-i18next';
import EntitiesManager from '../../EntitiesManager/EntitiesManager';
import Campaigns from '../../Campaigns/Campaigns';
import CampaignForm from '../../CampaignForm/CampaignForm';
// import WalletIcon from '@mui/icons-material/Wallet';
import UserForm from '../../UserForm/UserForm';
import Entity from '../../Entity/Entity';
import UserEntity from "../../UserForm/UserEntity"
import UsersManagement from '../../UsersManagement/UsersManagement';
import PdfViewerPage from "../../PdfViewerPage/PdfViewerPage"
import useMediaQuery from '../../../hooks/useMediaQuery'; // Chemin selon ton projet
import { useTheme } from 'styled-components';

function OwnerRoot({ userLevel, userType, bailleurId }) {
    const { t } = useTranslation();
    const theme = useTheme()
    const navigate = useNavigate()
    const Referrer = localStorage.getItem("parentLocation")?.split('/')?.pop();
    const isLaptop = useMediaQuery(`(max-width: ${theme.size.laptopL})`);
    
    //console.log(isLaptop)
    useEffect(() => {
        let nav = Referrer ? "/" + Referrer : "/";
        if (["usersManager", "entitiesManager"].includes(Referrer))
            navigate(nav)

    }, [Referrer])

    const menuItems = useMemo(() => (
        [
            { isLink: true, key: 'BackOffice', label: "Back Office", pathname: `${import.meta.env.VITE_WEB_APP_BAS_URL}/BackOffice`, icon: <SaveIcon /> },
            !isLaptop && {
                isLink: false, label: 'Exploitation informatique', key: 'exploitation', icon: <AdminPanelSettingsIcon />, subMenu: [               
                    { path: '/usersManager', hidden: false, label: t('navbar:emailsSettings', 'Gestion des utilisateurs') },
                    { path: '/entitiesManager', hidden: false, label: t('navbar:entitiesManager', 'Gestion des bailleurs') },              
                ]
            },
            isLaptop && { isLink: true, key: 'GestionUtilisateurs', pathname: '/usersManager', hidden: false, label: t('navbar:emailsSettings', 'Gestion des utilisateurs') },
            isLaptop && { isLink: true, key: 'GestionBailleurs', pathname: '/entitiesManager', hidden: false, label: t('navbar:entitiesManager', 'Gestion des bailleurs') },
        ]

    ), [t, isLaptop])

    const submenu=()=>{
        let menuTemp=menuItems;
        let temp = menuTemp.filter(item => item !== false)
        let menu= temp.map(item => {
            if(item.subMenu !== undefined){
                return { ...item, subMenu: item.subMenu.filter(item => item !== false) };
            }else{
                return item;
            }
        })
        return menu;
    }
          
    return (
        <>
            <AppContainer>
                <div style={{ display: "flex", justifyContent: "center", height: "100px", alignItems: "center" }}>

                    <Header isEnqueteSatisfaction={false} />

                </div>
                {/*<AppBody> remplacer par AppBodyBailleur*/} 
                <AppBodyBailleur>
                    <Menu items={submenu()} userType={userType} bailleurId={bailleurId } />
                    <AppContent >
                        <Routes>                          
                            <Route path="/entity/:uid" element={<Entity />} />                           
                            <Route path="/entity" element={<Entity/>} />
                            <Route path="/userForm/:uid" element={<UserForm />} />
                            <Route path="/userForm" element={<UserForm />} />
                            <Route path="/entitiesManager" element={<EntitiesManager />} />
                            <Route path="/suiviCampagnes" element={<Campaigns />} />
                            <Route path="/newCampaign" element={<CampaignForm />} />
                            <Route path="/newCampaign/:uid" element={<CampaignForm />} />
                            <Route path="/userEntity/:uid" element={<UserEntity />} />
                            <Route path="/userEntity" element={<UserEntity />} />                                          
                            <Route path="/usersManager" element={<UsersManagement />} />
                            <Route path="/showGuideTeledeclaration" element={<PdfViewerPage />} />
                            <Route path="/showGuideProduction" element={<PdfViewerPage />} />
                            <Route path="/" element={<EntitiesManager />} />
                        </Routes>
                    </AppContent>
                  
                </AppBodyBailleur>
                   <div style={{ display: "flex", justifyContent: "center", height: "60px", alignItems: "center", borderTop: "1px solid #e5e5e5" }}>

                    <div style={{ display: "flex", alignItems: "end", fontSize: "1rem" }}>
                        <p style={{ color: "#67748e" }}>
                            {("default:copyright", `© ${new Date().getFullYear()} - Créé par `)}<span style={{ color: "#0077cc" }}>Younov</span>
                        </p>
                    </div>

                </div>
            </AppContainer>
        </>
    )
}

export default OwnerRoot;
